import { createFileRoute } from "@tanstack/react-router";
import { KycPage } from "@/components/dashboard/kyc-page";
export const Route = createFileRoute("/kyc")({
 head:()=>({meta:[{title:"Identity verification — Deuxda Admin"},{name:"description",content:"Review identity documents and approve verification."},{property:"og:title",content:"Identity verification — Deuxda Admin"},{property:"og:description",content:"Review identity documents and approve verification."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component:()=> <KycPage/>,
});
